// ── Puente global "pregúntale a Benito" ──────────────────────────────────────
// Pieza 4 de "más toque de IA" (2026-08-01, "esto es lo que siempre he
// querido"): cualquier superficie profunda (un campo de las ramas, una escala)
// puede ofrecer llevarle una pregunta a Benito SIN prop-drilling de 4 niveles.
// App.jsx escucha el evento y abre el panel con el prefill.
//
// Regla intacta: Benito JAMÁS se abre solo. Este evento solo puede dispararse
// desde un toque explícito del usuario (el llamador es siempre un onClick).
export const EVENTO_BENITO_PREGUNTA = 'mipae:benito-pregunta';

export function preguntarleABenito(prefill) {
  if (!prefill || typeof prefill !== 'string') return;
  try {
    window.dispatchEvent(new CustomEvent(EVENTO_BENITO_PREGUNTA, { detail: { prefill } }));
  } catch { /* entorno sin CustomEvent: no hay panel que abrir */ }
}
